(function($) {

  $('.featured-team-member > .team-member-wrapper').each(function() {
  	$(this).magnificPopup({
		type: 'inline',
		items: [
			{
				src: '#'+$(this).attr('data-team-member'),
				type: 'inline'
			}
		],
		closeOnBgClick: true,
		closeOnContentClick: false,
		showCloseBtn: true,
		closeBtnInside: true,
		enableEscapeKey: false,
		callbacks: {
			open: function() {
				$('body').addClass('modal-open');
			},
			close: function() {
				$('body').removeClass('modal-open');
			}
		}
	});
  });

})(jQuery);
